import React, { useMemo } from 'react';
import ReactDom from 'react-dom';
import { Link, useLocation } from 'react-router-dom';
import cx from 'classnames';
import { formattedPathKey } from 'helpers/formattedPathKey';

import { get, SiteConfigManager } from '@atlas/core';
import {
  availableClientProfileRoutes,
  CLIENT_PROFILE_COMPONENT_TYPES,
  clientProfileRoutes,
  COMPONENT_TYPES,
  responsibleGamingAvailableRoutes,
} from '@atlas/routing';
import { Icon, Label, ScrollableContainer } from '@atlas/ui';

import ClientProfileTabNavigation from 'components/ClientProfile/ClientProfileTabNavigation';
import ResponsibleGamingRouter from 'components/ClientProfile/ResponsibleGaming/ResponsibleGamingRouter';
import SeoPageText from 'components/SeoPage/SeoPageText';
import ShortFooter from 'src/components/Footer/ShortFooter';

const { CLIENT_PROFILE } = COMPONENT_TYPES;
const { RESPONSIBLE_GAMING } = CLIENT_PROFILE_COMPONENT_TYPES;
const { responsibleGaming } = clientProfileRoutes;

const ResponsibleGaming = () => {
  const { pathname } = useLocation();

  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);
  const clientProfileTabs = get(SiteConfigManager.getComponentOptions(CLIENT_PROFILE), 'tabs');
  const responsibleGamingOptions = clientProfileTabs.find(
    ({ type }) => type === RESPONSIBLE_GAMING,
  );

  const { isExpandedOnMobile, tabs = [] } = responsibleGamingOptions;

  const activeTabs = useMemo(() => tabs.filter(tab => tab.isActive), [tabs]);

  const className = cx(
    'responsible-gaming-content-to-scroll',
    isExpandedOnMobile && 'disable-top-navigation',
  );

  const goBackMessage = isExpandedOnMobile
    ? formattedPathKey(pathname, clientProfilePath)
    : availableClientProfileRoutes[RESPONSIBLE_GAMING].name;

  return ReactDom.createPortal(
    <div className="profile-wrapper-absolute">
      <Link className="back-to-container" to={clientProfilePath}>
        <Icon className="icon-back" name="back" />
        <Label className="title-text" message={goBackMessage} />
      </Link>
      <ClientProfileTabNavigation
        availableRoutes={responsibleGamingAvailableRoutes}
        clientProfilePath={clientProfilePath}
        isExpandedOnMobile={isExpandedOnMobile}
        tabPath={responsibleGaming}
        tabs={activeTabs}
      />
      <ScrollableContainer className={className} id="content">
        <ResponsibleGamingRouter tabs={activeTabs} />
        <SeoPageText />
        <ShortFooter />
      </ScrollableContainer>
    </div>,
    document.body,
  );
};

export default ResponsibleGaming;
